export function HandlePrice(num, type) {
  var value = num === undefined || num === null ? '' : String(num);
  var parts = value.split('.');
  if (type) {
    return parts.length > 1 && parts[1] ? ".".concat(parts[1]) : '';
  }
  return parts[0];
}